import { IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react';
import ReplyIcon from '@mui/icons-material/Reply';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import { useTranslation } from 'react-i18next';
import { FundDataRoom } from '../../../../models/Fund';
import { LeoDocumentsPath, LeoDocumentsPathExample } from '../../../../resources/api-constants';

export interface IDataRoomArrayProps {
    dataRooms: FundDataRoom[];
}

const DataRoomArray: React.FC<IDataRoomArrayProps> = ({ dataRooms }) => {
    const { t, i18n } = useTranslation();
    
    const onDownload = () => {
        window.open(LeoDocumentsPath + '/' + LeoDocumentsPathExample);
    }

    return <Table sx={{ width: "100%", flexBasis: "100px", flexGrow: 1 }} aria-label="simple table">
        <TableHead>
            <TableRow>
                <TableCell>#</TableCell>
                <TableCell>{t('PortfolioDetailsReportsPortfolioDataRoomDocumentName')}</TableCell>
                <TableCell>{t('PortfolioDetailsReportsPortfolioDataRoomDate')}</TableCell>
                <TableCell>{t('PortfolioDetailsReportsPortfolioDataRoomAction')}</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {dataRooms.map((r, i) => <TableRow key={r.id}>
                <TableCell>{i + 1}.</TableCell>
                <TableCell sx={{ textDecoration: "underline" }}>{r.name}</TableCell>
                <TableCell>{r.date.toLocaleDateString(i18n.language)}</TableCell>
                <TableCell sx={{ display: "flex", gap: "5px", alignContent: "center" }}>
                    <IconButton size={"small"} onClick={onDownload}><ReplyIcon fontSize="small" /></IconButton>
                    <IconButton size={"small"} onClick={onDownload}><VerticalAlignBottomIcon fontSize="small" /></IconButton>
                </TableCell>
            </TableRow>)}
        </TableBody>
    </Table>
}

export default DataRoomArray